import React from 'react'
import { Table } from 'react-bootstrap';

import adData from '../../../json/icao-ad.json';

export default function MilitaryAdDisplay() {
    const MilitaryAd = adData.map((aerodromes, i) => {
        return aerodromes.military.map(function (military) {
            return (
                <React.Fragment key={military.icao}>
                    <tr>
                        <td >{military.id}</td>
                        <td >{military.icao}</td>
                        <td >{military.name}</td>
                        <td >{military.latitude}</td>
                        <td >{military.longitude}</td>
                    </tr>
                </React.Fragment>
            )
        }
        )
    }
    )
    return (
        <div>
            <Table striped bordered hover variant="dark">

                {/* <table className="table table-striped"> */}
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>ICAO</th>
                        <th>Latitude</th>
                        <th>Longitude</th>
                    </tr>
                </thead>
                <tbody>
                    {MilitaryAd}
                </tbody>
            </Table>
            {/* </table>              */}
        </div>
    )
}

